
























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import InfoIcon from '@/components/icons/InfoV2.vue';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import PerformanceItem from '@/components/molecules/PerformanceItem/PerformanceItem.vue';
import { ICardPerformance } from '@/models/performance';
import BillingPlanOverview from '@/componentsV2/molecules/BillingPlanOverview/BillingPlanOverview.vue';
import PinIcon from '@/components/icons/Pin.vue';
import FilmIcon from '@/components/icons/Film.vue';
import CoinNetworkPlanList from './CoinNetworkPlanList.vue';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import CoinNetworkAcceptanceModal from '@/componentsV2/templates/Modals/CoinNetworkAcceptanceModal/CoinNetworkAcceptanceModal.vue';
import BillingService from '@/api/BillingService';
import DateUtils from '@/utils/DateUtils';
import { abbreviateNumber } from '@/utils/currency';
import ClockSolidIcon from '@/components/icons/ClockSolid.vue';
import flagKeys from '@/constants/flagKeys';
import segmentIo from '@/utils/segment.io';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';
import {
  getBillingIsPending,
  getBillingOnboardingCallPending
} from '@/utils/billing';

@Component({
  components: {
    Page,
    Typography,
    Checkbox,
    InfoIcon,
    PerformanceItem,
    BillingPlanOverview,
    PinIcon,
    FilmIcon,
    CoinNetworkPlanList,
    CoinNetworkAcceptanceModal,
    ClockSolidIcon
  }
})
export default class CoinNetworkPlan extends Vue {
  @Prop({ default: false }) forceShowToggle?: boolean;
  service = new BillingService();

  loading = false;
  features: any = {};
  coinsWithTwism: any = ' ';
  coinsToCustomers: any = ' ';
  subscription: any = {};

  get performances(): ICardPerformance[] {
    return [
      {
        label: 'Coins to Twism',
        counter: this.coinsWithTwism,
        description: 'Total number of branded Coins held by Twism.'
      },
      {
        counter: this.coinsToCustomers,
        label: 'Coins to Members',
        description: 'Lifetime total number of Coins received by members.'
      }
    ];
  }

  get actions() {
    return [
      {
        label: 'Watch the Coin Network video',
        icon: 'FilmIcon',
        onClick: () => {
          segmentIo.track('Clicked Coin Network Watch Video');
          window.open('https://youtu.be/E7VaLrxOOKI', '_blank');
        }
      },
      {
        label: 'Manage my locations',
        icon: 'PinIcon',
        onClick: () => {
          segmentIo.track('Clicked Coin Network Manage Locations');
          this.$router.push('/settings/locations');
        }
      }
    ];
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get subscribedBilling() {
    return (
      this.billingStatus === EBillingStatusTypes.SUBSCRIBED ||
      this.billingStatus === EBillingStatusTypes.DELAY_PERIOD ||
      getBillingOnboardingCallPending()
    );
  }

  get billingStatus() {
    return this.businessInfo.subscriptionStatus;
  }

  get startMitingDate() {
    return DateUtils.formattedDate({
      date: this.subscription.nextPaymentAt
    });
  }

  get pendingBilling() {
    return getBillingIsPending();
  }

  get toggleLabel() {
    return {
      activeLabel: 'Active',
      inactiveLabel: 'Inactive'
    };
  }

  get tooltipMessage() {
    if (this.needsOnboardingCall) return 'Waiting for profile activation.';

    const date = DateUtils.formattedDate({
      date: this.subscribedBilling
        ? this.subscription.createdAt || this.subscription.startAt
        : this.subscription.endAt
    });

    return `Coin Network plan ${
      this.subscribedBilling ? 'activated' : 'deactivated'
    } on ${date}.`;
  }

  get needsOnboardingCall() {
    return getNeedsOnboardingCall();
  }

  get bannerTitle() {
    if (this.needsOnboardingCall)
      return `Your coin minting will start ${
        this.subscription.defaultDelayPeriod
      } days after your profile is activated.`;

    return `Your Coin minting will start on ${this.startMitingDate}`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showDelayedPeriodDisclaimer() {
    return (
      (this.billingStatus === EBillingStatusTypes.DELAY_PERIOD &&
        this.subscription.eligibleForDelayPeriod &&
        this.flags.includes(flagKeys.billingModuleV3)) ||
      (!this.loading && getBillingOnboardingCallPending())
    );
  }

  async loadOverviewData() {
    try {
      this.$showLoaderWithLocker();
      this.loading = true;
      const [{ data }, { data: features }] = await Promise.all([
        this.service.getBillingOverview(),
        this.service.getActivedFeatures()
      ]);

      this.$store.dispatch(
        'business/SET_BILLING_SUBSCRIPTION',
        data.subscription
      );

      this.features = features;
      this.coinsWithTwism = abbreviateNumber(
        Number(data.coinsWithTwism || 0),
        0
      );
      this.coinsToCustomers = abbreviateNumber(
        Number(data.coinsToCustomers || 0),
        0
      );

      this.subscription = data.subscription;
    } finally {
      this.loading = false;
      this.$hideLoader();
    }
  }

  onSubscribed() {
    this.loadOverviewData();
  }

  async changedActivation() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: this.subscribedBilling
          ? `coinNetworkDeactivationModal`
          : `coinNetworkReactivationModal`,
        hideCancelButton: false,
        icon: '',
        mobileFullScreen: true
      }),
      {
        subscription: this.subscription,
        features: this.features,
        origin: 'Coin Network Page Toggle'
      }
    );
  }

  mounted() {
    if (!this.pendingBilling) {
      this.loadOverviewData();
    }
  }

  created() {
    eventBus.$on('reloadCoinNetworkOverview', this.loadOverviewData);
  }

  beforeDestroy() {
    eventBus.$off('reloadCoinNetworkOverview', this.loadOverviewData);
  }
}
